import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Currency from 'components/UI/Currency'
import { METHODS } from 'http'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
  text-align: center;
`

export const Content = styled.div`
  display: flex;
  text-align: center;
  justify-content: space-between;
  width: 90%;
  margin: 20px auto 0 auto;
`

export const Price = styled.div`
  font-size: 40px;
  color: ${colors.darkPurple};
  text-align: center;
  margin: 8px 0 10px;
`

export const Product = styled.div`
  font-size: 12px;
  color: ${colors.pink};
  text-align: center;
`

export default class SelectPaymentTypePopup extends React.Component {
  constructor (props) {
    super(props)
  }

  static defaultProps = {
    product: {},
    plan: {}
  }

  render () {
    return (
      <DashboardPopup onCancel={this.props.onCancel}>
        <Product>{this.props.product.name}</Product>
        <Price><Currency amount={this.props.plan.amount / 100} currency={this.props.plan.currency} /></Price>
        <Title>How would you like to pay?</Title>
        <Content>
          <Button onClick={this.props.onCardSelect}>Card</Button>
          <Button onClick={() => this.props.onInvoiceSelect([{
            title: 'type',
            answer: 'Single class'
          }, {
            title: 'nbClasses',
            answer: 1
          }], this.props.plan)}>Invoice</Button>
        </Content>
      </DashboardPopup>
    )
  }
}
